import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
import Cache from '../cache/cache';
export default async function getProvince(context: Context, params: CustomQuery): Promise<ApiResult> {
  const cacheKey = 'getProvince_' + JSON.stringify(params);
  const cache = Cache.getCache(context, cacheKey);
  if (cache) {
    return cache;
  }
  const url = new URL('/mall/shop/province/list', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  Cache.setCache(context, cacheKey, res);
  return res;
}
